import { render, staticRenderFns } from "./CreateMendian.vue?vue&type=template&id=42fc60d5&"
import script from "./CreateMendian.vue?vue&type=script&lang=js&"
export * from "./CreateMendian.vue?vue&type=script&lang=js&"
import style0 from "./CreateMendian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports